import React, { memo } from 'react';
import { BreadcrumbJsonLd } from 'next-seo';
import { Link } from '@leafwell/components';

export type BreadcrumbsProps = {
  className?: string;
  items: { href: string; label: string }[];
};

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ className = '', items }) => {
  return (
    <>
      <BreadcrumbJsonLd
        itemListElements={items.map(({ href, label }, index) => ({
          position: index + 1,
          name: label,
          item: href,
        }))}
      />
      <ul
        {...{
          className: ['relative flex flex-wrap gap-2', className].join(' '),
        }}
      >
        {items.map(({ href, label }, index) => {
          const isLast = index === items.length - 1;

          return (
            <React.Fragment {...{ key: index }}>
              <li {...{ className: 'text-sm' }}>
                <Link
                  {...{
                    className: isLast ? '' : 'text-gray-400',
                    href,
                    variant: 'underlineHover',
                  }}
                >
                  {label}
                </Link>
              </li>
              {!isLast && (
                <li {...{ 'aria-hidden': 'true', className: 'text-sm' }}>
                  &gt;
                </li>
              )}
            </React.Fragment>
          );
        })}
      </ul>
    </>
  );
};

export default memo(Breadcrumbs);
